import React, { useState } from 'react';
import { Box, Paper, Typography, Button, Alert } from '@mui/material';
import AccountSelector from '../components/common/AccountSelector';
import { useLanguage } from '../contexts/LanguageContext';

const AccountSelectorTestPage: React.FC = () => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);

  const handleAccountChange = (accountId: number | null) => {
    setSelectedAccountId(accountId);
  };

  const handleClear = () => {
    setSelectedAccountId(null);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
        <Typography variant="h5" gutterBottom>
          {isRTL ? 'اختبار Account Selector' : 'Account Selector Test'}
        </Typography>

        <Box sx={{ mt: 3 }}>
          <AccountSelector
            value={selectedAccountId}
            onChange={handleAccountChange}
            label={isRTL ? 'اختر حساباً' : 'Select Account'}
            required
          />
        </Box>

        {selectedAccountId && (
          <Alert severity="success" sx={{ mt: 3 }}>
            <Typography variant="body2">
              <strong>{isRTL ? 'الحساب المختار:' : 'Selected Account:'}</strong>
            </Typography>
            <Typography variant="body2">
              Account ID: {selectedAccountId}
            </Typography>
          </Alert>
        )}

        <Box sx={{ mt: 3 }}>
          <Button variant="outlined" onClick={handleClear}>
            {isRTL ? 'مسح' : 'Clear'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AccountSelectorTestPage;